import { useQuery } from '@tanstack/react-query'

import type { UseAppQueryOptions } from '../../../types'
import {
  checkRecordsStatus,
  type CheckRecordsStatusOptions,
  type CheckRecordsStatusSchema
} from '../team.api'
import { teamsQueryKeys } from '../team.queryKeys'

export const useCheckTeamRecordStatus = (
  options: CheckRecordsStatusOptions,
  queryOptions?: UseAppQueryOptions<CheckRecordsStatusSchema>
) => {
  return useQuery({
    ...queryOptions,
    queryKey: teamsQueryKeys.checkRecordsStatus(options.teamId),
    queryFn: () => checkRecordsStatus(options)
  })
}
